import {useCallback, useEffect, useEffectEvent, useState} from 'react';
import type {HttpError} from '../http/types';
import type {DataLoadStatus} from '../types';

export const useGetResourceWithRefresh = <TItem>(get: () => Promise<TItem>) => {
  const [result, setResult] = useState<DataLoadStatus<TItem>>({
    status: 'NotLoaded',
  });

  const onSetResult = useEffectEvent(() => {
    setResult(old => ({status: 'Loading', data: old.data}));
    get()
      .then(data => {
        setResult(() => ({status: 'Loaded', data}));
      })
      .catch((error: HttpError) => {
        setResult(() => ({status: 'Failed', error}));
      });
  });

  const caller = useCallback(() => {
    setResult(old => ({status: 'Loading', data: old.data}));
    get()
      .then(data => {
        setResult(() => ({status: 'Loaded', data}));
      })
      .catch((error: HttpError) => {
        setResult(() => ({status: 'Failed', error}));
      });
  }, [get, setResult]);

  useEffect(() => {
    onSetResult();
  }, [get]);

  return {
    result,
    refresh: () => caller(),
  };
};
